<button
  type="button"
  ngpRadioItem
  ngpFocus
  [ngpRadioItemValue]="value"
  [ngpRadioItemDisabled]="effectiveDisabled()"
  [disabled]="effectiveDisabled()"
>
  <span ngpRadioIndicator class="indicator" aria-hidden="true"></span>
  <ng-content />
</button>
